import { Flex } from "@chakra-ui/layout";
import { Icon } from "@src/components/ui-kit/Icon";
import type React from "react";
import type { FunctionComponent } from "react";

export const CardIcon = () => (
  <Flex
    w="10"
    h="10"
    borderRadius="50%"
    align="center"
    justify="center"
    bg="teal.500"
  >
    <Icon name="wallet-02" color="white" />
  </Flex>
);
export const CardAvatar = () => (
  <div className="w-16 h-16 rounded-full inline-flex items-center justify-center bg-inkLightest" />
);

export const InfoCardRow: FunctionComponent<
  React.PropsWithChildren<{
    title: string;
    value?: string | number | null;
  }>
> = ({ title, value }) => (
  <div className="flex items-center mb-3">
    <span className="mr-2 font-bold text-ink">{title}</span>
    <span>{value || ""}</span>
  </div>
);

export const CardHeader: FunctionComponent<
  React.PropsWithChildren<{
    title: string;
    icon: React.ReactNode;
  }>
> = ({ title, icon }) => (
  <div className="flex items-center py-2 mb-6">
    <span className="mr-5">{icon}</span>
    <h2 className="text-2xl font-bold">{title}</h2>
  </div>
);
